import * as React from 'react';
import { CheckoutBreakdownHover } from '../CheckoutBreakdownHover';
import { PricingSeatSelect } from '../PricingSeatSelect';
import { BonusBalanceSection } from '../BonusBalanceSection';
import { CustomPlanDescription } from '../CustomPlanDescription';
import { trialBonus, v4PlanPrices, calcPriceTotal } from '../../../../constants/pricing';

interface PricingPlanSectionProps {
  planId: string;
  handleSeatChange: (any) => void;
  seatCount: number;
  togglePayPeriod: string;
  planName: string;
}

export const PricingPlanSection = ({
  planId,
  handleSeatChange,
  seatCount,
  togglePayPeriod,
  planName,
}: PricingPlanSectionProps) => {
  if (planId === 'custom') return <CustomPlanDescription />;

  const [showPriceHover, setShowPriceHover] = React.useState(false);

  let priceTotalComp;

  const isTrialPlan = planId === 'trial-plan-4';
  const isMonthlyPayPeriod = togglePayPeriod === 'monthly';
  const key = isTrialPlan ? 'trial-plan-4' : `${planId}-${togglePayPeriod}`;
  const seatPricePerMonth = v4PlanPrices[key].seatPrice;
  const platformPricePerMonth = v4PlanPrices[key].platformPrice;
  const seatPrice = calcPriceTotal(togglePayPeriod, seatPricePerMonth);
  const platformTotal = calcPriceTotal(togglePayPeriod, platformPricePerMonth);
  const seatsTotal = seatCount * seatPrice;
  const checkoutTotal = `$${(seatsTotal + platformTotal).toLocaleString()}`;
  const priceHoverClass = `hover-state ${showPriceHover ? '' : 'hide'}`;
  const ref = React.useRef<HTMLInputElement>();
  const paidPlanBonus = `$${v4PlanPrices[key].bonusBalancePerSeat * seatCount}`;

  if (planId !== 'trial-plan-4') {
    priceTotalComp = (
      <div className="mt-20 mb-5">
        <span className="bold-800 fsz-20">Billed&nbsp;</span>
        <span className="bold-800 fsz-20">{isMonthlyPayPeriod ? 'monthly' : 'annually'}</span>
        :&nbsp;
        <span>
          <span className="bold-800 fsz-20">{checkoutTotal}</span>
          &nbsp;
          <span
            className="orange info-icon"
            onMouseEnter={() => setShowPriceHover(true)}
            onMouseLeave={() => setShowPriceHover(false)}
          >
            ⓘ
          </span>
          <CheckoutBreakdownHover
            priceHoverClass={priceHoverClass}
            planName={planName}
            isMonthlyPayPeriod={isMonthlyPayPeriod}
            seatCount={seatCount}
            seatPrice={seatPricePerMonth}
            seatsTotal={`$${seatsTotal.toLocaleString()}`}
            platformPrice={platformPricePerMonth}
            platformTotal={`$${platformTotal.toLocaleString()}`}
            checkoutTotal={checkoutTotal}
            paidPlanBonus={`$${v4PlanPrices[key].bonusBalancePerSeat * seatCount}`}
          />
        </span>
      </div>
    );
  }

  return (
    <>
      <PricingSeatSelect
        planId={planId}
        seatCount={seatCount}
        handleSeatChange={handleSeatChange}
        reactRef={ref}
      />
      <BonusBalanceSection
        planName={planName}
        bonus={isTrialPlan ? `$${trialBonus}` : paidPlanBonus}
      />
      {priceTotalComp}
    </>
  );
};
